import { render, staticRenderFns } from "./MainStore.vue?vue&type=template&id=20115160"
import script from "./MainStore.vue?vue&type=script&lang=js"
export * from "./MainStore.vue?vue&type=script&lang=js"
import style0 from "./MainStore.vue?vue&type=style&index=0&id=20115160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports